import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'underscore';
import * as moment from 'moment';
import 'moment-duration-format';
import {LocalStorageService, SessionStorageService} from 'ngx-webstorage';
import { Observable } from 'rxjs';
import {switchMap, take} from 'rxjs/operators';
import MyClass from './MyClass';
import UserInterface from './UserInterface';
import Scenes from './Scenes';
import {ActivatedRoute} from '@angular/router';
import {GoogleAnalyticsService} from '../google-analytics.service';
import Panolens from './Panolens';
import {PanotestComponent} from './panotest.component';
import {QuizQuestion, QuizGroup} from '../quiz/quiz/quiz.component';



const PANOLENS = Panolens.PANOLENS;



@Injectable({
  providedIn: 'root'
})

export class PanotestService {

  version = "1.0";
  sceneData: Scene[];
  sceneData1: Scene[];
  sceneData2: [];


  menu: Panolens;
  PANO: any;
  panorama1: Panolens;
  panorama2: Panolens;
  panorama3: Panolens;
  panorama4: Panolens;
  panorama5: Panolens;
  panorama6: Panolens;
  panorama7: Panolens;
  panorama8: Panolens;
  panorama9: Panolens;
  panorama10: Panolens;
  panorama11: Panolens;
  panorama12: Panolens;
  panoramaArray: any[];

  game: MyClass;
  ui: UserInterface;
  scenes: Scenes;
  scope: PanotestComponent;

  //for html feedback on quizzes.
  htmlFeedback: string = '';

  quizGroup1: QuizGroup = {
    id: 1,
    submit: true,


    questions: [

      {
        id: 1,
        question: 'Are the following sentences correct or incorrect?',
        responseType: 2,
        responses: [
          {id: 1, text: 'I am looking for book about Vietnam?', weight: 1},
          {id: 2, text: 'Does the library have any journals that focus on Global Warming?', weight: 0},
          {id: 3, text: 'I’m after an economics textbook', weight: 0},
          {id: 4, text: 'I’m wondering the library has any novels', weight: 1},
        ],
        type: 2.2,
        answer: [1],
        submit: true,
        passed: false,
        feedback: {
          correct: 'That’s right!',
          incorrectHTML: 3
        }

      }

    ]
  }
  quizGroup2: QuizGroup = {
    id: 1,
    cycle: true,
    style: {width: '40%'},
    feedback: {
      correct: 'Well done. You have answered all the questions correctly.',
      incorrect: 'Not bad. Let\'s explore more of the ACU Library.'
    },
    questions: [

      {
        id: 1,
        question: 'What is the poem about? ',
        responses: [
          {id: 0, text: '', weight: 0},
          {id: 1, text: 'helping people', weight: 1},
          {id: 2, text: 'recovering from injury', weight: 0},
          {id: 3, text: 'helping animals', weight: 0},

        ],
        type: 3,
        answer: [1],
        feedback: {
          correct: 'That\'s right.',
          incorrect: 'Not quite. The poem is about helping people.'
        }

      },
      {
        id: 2,
        question: 'What does ‘I shall not live in vain’ mean?',
        responses: [
          {id: 0, text: '', weight: 0},
          {id: 1, text: 'I will not get in trouble', weight: 0},
          {id: 2, text: 'I will not waste my life', weight: 1},
          {id: 3, text: 'I will not be poor', weight: 0},

        ],
        type: 3,
        answer: [1],
        feedback: {
          correct: 'Well done. You are correct.',
          incorrect: 'Not quite. It means I will not waste my life.'
        }

      }

    ]
  }
  quizGroup3: QuizGroup = {
      id: 2,
    style: {top: '8%', width: '50%'},
      submit: true,
      feedback: {
        correct: 'That’s right!',
        incorrect: '<h2>Not quite.</h2><p>It is a group presentation which will be 10 minutes long. The group divided the presentation evenly between two of the students.</p>'
      },
      questions: [

        {
          id: 1,
          question: 'Is it a group or individual presentation?',
          responses: [
            {id: 1, text: ' ', weight: 0},
            {id: 2, text: 'Group', weight: 1},
            {id: 3, text: 'Individual', weight: 0},

          ],
          type: 3,
          answer: [1],
          feedback: {
            correct: 'Well done. You are correct.',
            incorrect: 'Not quite. Maybe try again?'
          }

        },
        {
          id: 2,
          question: 'How long is the presentation going to be?',
          responses: [
            {id: 1, text: ' ', weight: 0},
            {id: 1, text: '50 minutes', weight: 0},
            {id: 2, text: '10  minutes', weight: 1}

          ],
          type: 3,
          answer: [1],
          feedback: {
            correct: 'Well done. You are correct.',
            incorrect: 'Not quite. Maybe try again?'
          }

        },
        {
          id: 3,
          question: 'How did the students decide to divide the presentation?',
          responses: [
            {id: 0, text: ' ', weight: 0},
            {id: 1, text: 'Evenly between the two students', weight: 1},
            {id: 2, text: 'Each will do one problem and one solution', weight: 0}
          ],
          type: 3,
          answer: [1],
          feedback: {
            correct: 'Well done. You are correct.',
            incorrect: 'Not quite. Maybe try again?'
          }

        }

      ]
    }
  quizGroup4: QuizGroup = {
    id: 3,
    cycle: true,
    feedback: {
      correct: '<h2>Well done.</h2><p>It seems you know the slang words when visiting a pub in Australia.</p><p>Close the quiz to continue.</p>',
      incorrect: '<h2>Not quite.</h2><p>Now you know some slang words for visiting pubs in Austrlaia.</p><p>Close the quiz to continue.</p>'
    },
    questions: [
      {
        id: 1,
        question: '<p class="prompt">Read the question then choose your answer.</p><p>What does the slang word ‘pub’ mean?</p>',
        responses: [
          {id: 1, text: 'a place which serves alcohol and food', weight: 1},
          {id: 2, text: 'a place for the public to gather' , weight: 0},
          {id: 3, text: 'a place where you can get a coffee', weight: 0},
        ],
        type: 1.1,
        answer: [1],
        feedback: {
          correct: '<h2>That’s right!</h2><p>A pub is a place which serves alcohol and food.</p>',
          incorrect: '<h2>Not quite.</h2><p>A pub is a place which serves alcohol and food.</p>'
        }

      },
      {
        id: 2,
        question: '<p class="prompt">Time for another question! Pick your answer.</p><p>What kind of meal do you think you would find in a typical Australian pub?</p>',
        responses: [
          {id: 1, text: 'a small snack', weight: 0},
          {id: 2, text: 'a large meal with chips', weight: 1},
          {id: 3, text: 'a healthy salad', weight: 0},


        ],
        type: 1.1,
        answer: [1],
        feedback: {
          correct: '<h2>Well done!</h2><p>Pubs are most famous for their large meals with chips.</p>',
          incorrect: '<h2>Not quite.</h2><p>Pubs are most famous for their large meals with chips.</p>'
        }
        },
        {
        id: 3,
        question: '<p class="prompt">Last question! Choose your answer.</p><p>Select the correct word to complete the sentence you would use when ordering beer in a Melbourne pub:</p><p>Could I please have a _______ of beer.</p>',
        responses: [
          {id: 1, text: 'glass', weight: 0},
          {id: 2, text: 'pot' , weight: 1},
          {id: 3, text: 'drink', weight: 0},

        ],
        type: 1.1,
        answer: [1],
        feedback: {
          correct: '<h2>That’s right!</h2><p>In Melbourne, a small beer is called a pot. If you want to order a large beer you order a pint or a schooner.</p>',
          incorrect: '<h2>Not quite.</h2><p>In Melbourne, a small beer is called a pot. If you want to order a large beer you order a pint or a schooner.</p>'
        }

      }

    ]

  }
  quizGroup5: QuizGroup = {
    id: 1,
    cycle: true,
    style: {width: "40%"},
    feedback: {
      correctHTML: 2,
      incorrectHTML: 1
    },
    questions: [

      {
        id: 1,

        question: '<p>Traditional ceremonies, music, dance and art are all important aspects of aboriginal culture. Look at some of the Aboriginal symbols below that are used in their art. Can you guess what they mean? </p><div class="centerImg abo"><img style="width: 300px" src="./assets/images/acu/s01-symbol01-Camp_Fire.png" class="imgFluid questionImage"></div>',
        responses: [
          {id: 0, text: 'Please select', weight: 0},
          {id: 1, text: 'Flower', weight: 0},
          {id: 2, text: 'Sun', weight: 0},
          {id: 3, text: 'People sitting around fire', weight: 1},


        ],
        type: 3,
        answer: [1],
        feedback: {
          correct: '<h2>That is correct!</h2><p>The image represents people sitting around a fire.</p>',
          incorrect: '<h2>Not quite.</h2><p>The image represents people sitting around a fire.</p>'
        }

      },
      {
        id: 2,
        question: '<p>Traditional ceremonies, music, dance and art are all important aspects of aboriginal culture. Look at some of the Aboriginal symbols below that are used in their art. Can you guess what they mean? </p><div class="centerImg abo"><img style="width: 300px" src="./assets/images/acu/s01-symbol02-Person.png" class="imgFluid questionImage"></div>',
        responses: [
          {id: 0, text: 'Please select', weight: 0},
          {id: 1, text: 'Bridge', weight: 0},
          {id: 2, text: 'Person', weight: 1},
          {id: 3, text: 'Cave', weight: 0},

        ],
        type: 3,
        answer: [1],
        feedback: {
          correct: '<h2>That is correct!</h2><p>The image represents a person.</p>',
          incorrect: '<h2>Not quite.</h2><p>The image represents a person.</p>'
        }

      },
      {
        id: 3,
        question: '<p>Traditional ceremonies, music, dance and art are all important aspects of aboriginal culture. Look at some of the Aboriginal symbols below that are used in their art. Can you guess what they mean? </p><div class="centerImg abo"><img style="width: 300px" src="./assets/images/acu/s01-symbol03-Kangaroo.png" class="imgFluid questionImage"></div>',
        responses: [
          {id: 0, text: 'Please select', weight: 0},
          {id: 1, text: 'Kangaroo', weight: 1},
          {id: 2, text: 'Arrow', weight: 0},
          {id: 3, text: 'Tree', weight: 0},

        ],
        type: 3,
        answer: [1],
        feedback: {
          correct: '<h2>That is correct!</h2><p>The image represents a kangaroo</p>',
          incorrect: '<h2>Not quite.</h2><p>The image represents a kangaroo.</p>'
        }

      }

    ]
  }

  quizGroup6: QuizGroup = {
    id: 6,
    submit: true,
    feedback: {
      correctHTML: 5,
      incorrectHTML: 4
    },
    audioPrompt: 'assets/audio/0035-acu-audio-35.mp3',
    questions: [
      {
        id: 1,
        question: '<p>Choose a phrase from Column A then click the matching phrase from column B.</p>',
        responses: [
          {text: 'Have', id: 4, weight: 1},
          {text: 'How are you?', id: 3, weight: 2},
          {text: 'Thank you', id: 2, weight: 3},
          {text: 'You’re welcome', id: 1, weight: 4}
        ],
        type: 5,
        answer: [1],
        feedback: {
          correct: '',
          incorrect: ''
        }

      }
    ]
  }

  //Dummy question. Logic done by html
  quizGroup7: QuizGroup = {
    id: 7,
    style: {top: '5%', width: '50%'},
    feedback: {
      correctHTML: 2,
      incorrectHTML: 1
    },
    questions: [
      {id: 99, question: '', responses:[], type: 99, answer: [0]}
    ]
  }

  //Royal Arcade
  quizGroup8: QuizGroup = {
    id: 8,
    cycle: true,
    style: {top: '5%', width: '37%'},
    feedback: {
      correct: 'That’s right! You have a great understanding of where you can shop in Melbourne!',
      incorrectHTML: 6
    },
    questions: [

      {
        id: 1,

        question: '<p>As you have learned, there are several types of places you can go shopping in Melbourne.</p><p>Match the places with the images:</p><div class="centerImg w80p" ><img src="./assets/images/acu/s04-img02-Pedestrian_Mall.png" class="imgFluid questionImage"></div>',
        responses: [
          {id: 0, text: 'Please select', weight: 0},
          {id: 1, text: 'An arcade', weight: 0},
          {id: 2, text: 'A pedestrian mall', weight: 1},
          {id: 3, text: 'A department store', weight: 0},

        ],
        type: 3,
        answer: [1],
        feedback: {
          correct: '',
          incorrect: ''
        }


      },
      {
        id: 2,
        question: '<p>As you have learned, there are several types of places you can go shopping in Melbourne.</p><p>Match the places with the images:</p><div class="centerImg w80p" ><img src="./assets/images/acu/s04-img01-Arcade.png" class="imgFluid questionImage"></div>',
        responses: [
          {id: 0, text: 'Please select', weight: 0},
          {id: 1, text: 'An arcade', weight: 1},
          {id: 2, text: 'A pedestrian mall', weight: 0},
          {id: 3, text: 'A department store', weight: 0},

        ],
        type: 3,
        answer: [1],
        feedback: {
          correct: '',
          incorrect: ''
        }

      },
      {
        id: 3,
        question: '<p>As you have learned, there are several types of places you can go shopping in Melbourne.</p><p>Match the places with the images:</p><div class="centerImg w80p" ><img src="./assets/images/acu/s04-img03-Department_Store.png" class="imgFluid questionImage"></div>',
        responses: [
          {id: 0, text: 'Please select', weight: 0},
          {id: 1, text: 'An arcade', weight: 0},
          {id: 2, text: 'A pedestrian mall', weight: 0},
          {id: 3, text: 'A department store', weight: 1},

        ],
        type: 3,
        answer: [1],
        feedback: {
          correct: '',
          incorrect: ''
        }

      }

    ]
  }

  //Shopping
  quizGroup9: QuizGroup = {
    id: 9,
    cycle: true,
    style: {width: '40%'},
    feedback: {
      correctHTML: 8,
      incorrectHTML: 9,
    },
    questions: [
      {
        id: 1,
        question: '<p>What does the term ‘window shopping’ mean?</p>',
        responses: [
          {id: 1, text: 'to shop for windows ', weight: 0},
          {id: 2, text: 'to look at things but not to buy them' , weight: 1},
          {id: 3, text: 'to buy some items', weight: 0},
        ],
        type: 1,
        answer: [1],
        feedback: {
          correct: '<h2>Well done!</h2>',
          incorrect: '<h2>Not quite.</h2><p>Window shopping is to look at things but not to buy them.</p>'
        }

      },
      {
        id: 2,
        question: '<p>What is a trend?</p>',
        responses: [
          {id: 1, text: 'a thing that has suddenly become popular', weight: 1},
          {id: 2, text: 'an item of clothing', weight: 0},
          {id: 3, text: 'a thing that you can eat ', weight: 0},


        ],
        type: 1,
        answer: [1],
        feedback: {
          correct: '<h2>That’s right!</h2>',
          incorrect: '<h2>Not quite.</h2><p>A trend is a thing that has suddenly become popular.</p>'
        }
      },
      {
        id: 3,
        question: '<p>What is a bargain?</p>',
        responses: [
          {id: 1, text: 'Something that is rare and hard to find', weight: 0},
          {id: 2, text: 'Something that is worth buying' , weight: 0},
          {id: 3, text: 'Something that is very well priced', weight: 1},

        ],
        type: 1,
        answer: [1],
        feedback: {
          correct: '<h2>Great job!</h2>',
          incorrect: '<h2>Not quite.</h2><p>A bargain is something that is very well priced.</p>'
        }

      },
      {
        id: 4,
        question: '<p>What does ‘on special’ mean?</p>',
        responses: [
          {id: 1, text: 'That something is very unique', weight: 0},
          {id: 2, text: 'That something is less expensive than it used to be' , weight: 1},
          {id: 3, text: 'That something is old', weight: 0},

        ],
        type: 1,
        answer: [1],
        feedback: {
          correct: '<h2>Nice one!</h2><p>On special means that something is less expensive than it used to be.</p>',
          incorrect: '<h2>Not quite.</h2><p>On special means that something is less expensive than it used to be.</p>'
        }

      }

    ]

  }

  //Immigration
  quizGroup10: QuizGroup = {
    id: 10,
    cycle: true,
    style: {width: '30%'},
    feedback:{
      correctHTML: 14,
      incorrectHTML: 14
    },
    questions: [
      {
        id: 1,
        question: '<p>How many people living in Australia were born overseas?</p>',
        responses: [
          {id: 1, text: '.3 million ', weight: 0},
          {id: 2, text: '7.5 million' , weight: 1},
          {id: 3, text: '10 thousand', weight: 0},
        ],
        type: 1,
        answer: [1],
        feedback: {
          correct: '<h2>That’s right! </h2><p>7.5 million people living in Australia were born overseas.</p>',
          incorrect: '<h2>Not quite.</h2><p>7.5 million people living in Australia were born overseas.</p>'
        }

      },
      {
        id: 2,
        question: '<p>How many Australians speak a language other than English at home?</p>',
        responses: [
          {id: 1, text: '50%', weight: 0},
          {id: 2, text: '5%', weight: 0},
          {id: 3, text: '20%', weight: 1},


        ],
        type: 1,
        answer: [1],
        feedback: {
          correct: '<h2>Exactly! </h2><p>20% of Australians speak a language other than English at home.</p>',
          incorrect: '<h2>Not quite.</h2><p>20% of Australians speak a language other than English at home.</p>'
        }
      }

    ]

  }


  //Pets
  quizGroup11: QuizGroup = {
    id: 11,
    cycle: true,
    style: {width: '40%'},
    feedback: {
      correctHTML: 12,
      incorrectHTML: 13,
    },
    questions: [
      {
        id: 1,
        question: '<p>Australia has the highest pet ownership in the world.</p>',
        responses: [
          {id: 1, text: 'True', weight: 1},
          {id: 2, text: 'False' , weight: 0}

        ],
        type: 1,
        answer: [1],
        feedback: {
          correct: '<h2>That’s right! </h2><p>Australia has the highest pet ownership in the world.</p>',
          incorrect: '<h2>Not quite.</h2><p>Australia has the highest pet ownership in the world.</p>'
        }

      },
      {
        id: 2,
        question: '<p>How many households in Australia own a dog?</p>',
        responses: [
          {id: 1, text: '39%', weight: 1},
          {id: 2, text: '62%', weight: 0},
          {id: 3, text: '15%', weight: 0},


        ],
        type: 1,
        answer: [1],
        feedback: {
          correct: '<h2>Correct! </h2><p>39% of Australian households own a dog.</p>',
          incorrect: '<h2>Not quite.</h2><p>39% of Australian households own a dog.</p>'
        }
      }

    ]

  }
  //Study
  quizGroup12: QuizGroup = {
    id: 12,
    cycle: true,
    style: {width: '40%'},
    feedback: {
      correctHTML: 10,
      incorrectHTML: 11
    },
    questions: [
      {
        id: 1,
        question: '<p>Is this statement about studying in Australian universities true or false?</p><p> Select your answer then click Submit.</p><p><b>Students at ACU sometimes have to wear uniforms.</b></p>',
        responses: [
          {id: 1, text: 'True', weight: 1},
          {id: 2, text: 'False' , weight: 0}

        ],
        type: 1,
        answer: [1],
        feedback: {
          correct: '<h2>That’s right! </h2><p>Nursing students at ACU have to wear uniforms when they have practical classes. But usually students don’t have to wear uniforms.</p>',
          incorrect: '<h2>Not quite.</h2><p>Nursing students at ACU have to wear uniforms when they have practical classes. But usually students don’t have to wear uniforms.</p>'
        }

      },
      {
        id: 2,
        question: '<p>Is this statement about studying in Australian universities true or false?</p><p>Select your answer then click Submit.</p><p><b>There are no bells or alarms when classes finish at ACU.</b></p>',
        responses: [
          {id: 1, text: 'True', weight: 1},
          {id: 2, text: 'False' , weight: 0}


        ],
        type: 1,
        answer: [1],
        feedback: {
          correct: '<h2>Correct! </h2><p>Universities in Australia don’t have any bells or sirens.</p>',
          incorrect: '<h2>Not quite.</h2><p>Universities in Australia don’t have any bells or sirens.</p>'
        }
      },
      {
        id: 3,
        question: '<p>Is this statement about studying in Australian universities true or false?</p><p>Select your answer then click Submit.</p><p><b>Students at ACU should use their teachers’ family name when talking with them.</b></p>',
        responses: [
          {id: 1, text: 'True', weight: 0},
          {id: 2, text: 'False' , weight: 1}
        ],
        type: 1,
        answer: [1],
        feedback: {
          correct: '<h2>That’s right.</h2><p>At universities in Australia, it is usual to use teachers’ first names when talking with them.</p>',
          incorrect: '<h2>Not quite.</h2><p>At universities in Australia, it is usual to use teachers’ first names when talking with them.</p>'
        }
      }

    ]

  }
  //Food
  quizGroup13: QuizGroup = {
    id: 13,
    submit: true,
    tryAgain: true,
    feedback: {
      correctHTML: 7,
      incorrectHTML: 7
    },
    questions: [

      {
        id: 1,
        question: 'Select whether these statements about Australian food are True or False:',
        responses: [
          {id: 1, text: 'Tim Tams were named after a horse.', weight: 1},
          {id: 2, text: 'Tim Tams are older than vegemite.', weight: 0},
          {id: 3, text: 'Milo is only popular in Australia.', weight: 0},
          {id: 4, text: 'Vegemite is considered healthy.', weight: 1},
        ],
        type: 2.1,
        answer: [1],
        submit: true,
        passed: false,

      }

    ]
  }
  constructor(private route: ActivatedRoute, private gaService: GoogleAnalyticsService) {

  }


  //PANOS
  initPanoObjects(){
    let imagePath = 'assets/images/backgrounds/panos/high/';
    //if(this.game.ua.platform=='iPad') imagePath = 'assets/images/backgrounds/panos/low/';

    //imagePath = 'assets/images/backgrounds/panos/low/';

    //SET SCENE IDS TO MATCH SCENEDATA IDS BELOW
    this.menu       = new PANOLENS.ImagePanorama(imagePath + 'menu/hall.jpg'); //Foyer Grocery
    this.menu.sceneId = 0;
    this.menu.name = 'Menu';

    this.panorama1  = new PANOLENS.ImagePanorama(imagePath + 'topic1/court.jpg', 60);
    this.panorama1.sceneId = 1;
    this.panorama1.name = 'Court';



    this.panorama2  = new PANOLENS.ImagePanorama(imagePath + 'topic1/classroom.jpg', 60);
    this.panorama2.sceneId = 2;
    this.panorama2.name = 'Classroom';

    this.panorama3  = new PANOLENS.ImagePanorama(imagePath + 'topic1/library.jpg', 60);
    this.panorama3.sceneId = 3;
    this.panorama3.name = 'Library';

    this.panorama4  = new PANOLENS.ImagePanorama(imagePath + 'topic1/hall.jpg', 60);
    this.panorama4.sceneId = 4;
    this.panorama4.name = 'Hall';

    this.panorama5  = new PANOLENS.ImagePanorama(imagePath + 'topic1/roof.jpg', 60);
    this.panorama5.sceneId = 5;
    this.panorama5.name = 'Rooftop';

    this.panorama6  = new PANOLENS.ImagePanorama(imagePath + 'topic1/flinders.jpg', 60);
    this.panorama6.sceneId = 6;
    this.panorama6.name = 'Flinders';

    this.panorama7  = new PANOLENS.ImagePanorama(imagePath + 'topic1/degraves.jpg', 60);
    this.panorama7.sceneId = 7;
    this.panorama7.name = 'Degraves';

    this.panorama8  = new PANOLENS.ImagePanorama(imagePath + 'topic1/bourke.jpg', 60);
    this.panorama8.sceneId = 8;
    this.panorama8.name = 'Bourke';

    this.panorama9  = new PANOLENS.ImagePanorama(imagePath + 'topic1/royal.jpg', 60);
    this.panorama9.sceneId = 9;
    this.panorama9.name = 'Royal Arcade';

    this.panorama10  = new PANOLENS.ImagePanorama(imagePath + 'topic1/treasury.jpg', 60);
    this.panorama10.sceneId = 10;
    this.panorama10.name = 'Treasury Building';

    this.panorama11  = new PANOLENS.ImagePanorama(imagePath + 'topic1/gardens.jpg', 60);
    this.panorama11.sceneId = 11;
    this.panorama11.name = 'Exhibition';

  }



  initPano() {

    //add panos.Images loaded when scene is loaded into view
    //this.menu = new PANOLENS.ImagePanorama('assets/images/backgrounds/panos/front.jpg', 120);

    this.initPanoObjects(); //Populate our panos we will be using

    this.PANO = {
      MENU: this.menu,
      COURT: this.panorama1,
      HALL: this.panorama2,
      CLASSROOM: this.panorama3,
      LIBRARY: this.panorama4,
      ROOF: this.panorama5,



    };

    this.panoramaArray = [
      this.menu, this.panorama1, this.panorama2, this.panorama3, this.panorama4, this.panorama5, this.panorama6, this.panorama7, this.panorama8, this.panorama9, this.panorama10, this.panorama11

    ];

    this.scope.setupPanoListeners();

    //Define each scene. Nasty errors if you dont define these for each pano. The pano will load but errors around scene items.


    //Menu
    this.sceneData = [
      {
        id: 0,
        built: false,
        fov: 90,
        widgetStore: [],
        title: 'Menu',
        desc: '',
        lookAtTarget: [{from: 0, x: 1500, y: -40, z: 1520}],
        pano: _.findWhere(this.panoramaArray,{name: 'Menu'}),
        topic: 0,


        fadeStart: function () {
          //PANOLENS.clientScope.panorama15.toggleInfospotVisibility(false, 3400);

        },
        fadeComplete: () => {
          this.ui.sceneReady = true;
          console.log('Scene 2 load complete');

        },
        widgets: []


      }
    ];

    //Welcome


    this.sceneData1 = [

      {
        id: 1,
        topic: 1,
        built: false,
        fov: 95,
        widgetStore: [],
        title: 'Sister of the Mary Cross Courtyard',
        desc: 'Sister of the Mary Cross Courtyard',
        lookAtTarget: [
          {from: 0, x: 1120, y: -260, z: 860, desc: 'from scene 1'},
        ],
        pano: _.findWhere(this.panoramaArray,{name: 'Court'}),
        widgets: []

      },
      {
        id: 2,
        topic: 1,
        built: false,
        fov: 95,
        widgetStore: [],
        title: 'Classroom',
        desc: 'Classroom',
        lookAtTarget: [
          {from: 0, x: 1120, y: -260, z: 860, desc: 'from scene 1'},
        ],
        pano: _.findWhere(this.panoramaArray,{name: 'Classroom'}),
        widgets: []

      },
      {
        id: 3,
        topic: 1,
        built: false,
        fov: 95,
        widgetStore: [],
        title: 'ACU Library',
        desc: 'Library',
        lookAtTarget: [
          {from: 0, x: 920, y: -160, z: -1700, desc: 'from classroom'},
        ],
        pano: _.findWhere(this.panoramaArray,{name: 'Library'}),
        widgets: []

      },
      {
        id: 4,
        built: false,
        fov: 90,
        widgetStore: [],
        title: 'Cathedral Hall',
        desc: 'Cathedral Hall',
        lookAtTarget: [{from: 0, x: -1580, y: 360, z: -2940, desc: 'from menu'}],
        pano: _.findWhere(this.panoramaArray,{name: 'Hall'}),
        topic: 1,
        widgets: []

      },
      {
        id: 5,
        built: false,
        fov: 90,
        widgetStore: [],
        title: 'Rooftop Cafe',
        desc: 'Rooftop Cafe',
        lookAtTarget: [{from: 0, x: 3260, y: -200, z: -920, desc: 'from menu'}],
        pano: _.findWhere(this.panoramaArray,{name: 'Rooftop'}),
        topic: 1,
        widgets: []

      },
      {
        id: 6,
        built: false,
        fov: 90,
        widgetStore: [],
        title: 'Flinders Street Station',
        desc: 'Flinders Street Station',
        lookAtTarget: [{from: 0, x: 1040, y: 960, z: 2820, desc: 'from menu'}],
        pano: _.findWhere(this.panoramaArray,{name: 'Flinders'}),
        topic: 1,
        widgets: []

      },
      {
        id: 7,
        built: false,
        fov: 90,
        widgetStore: [],
        title: 'Degraves Street',
        desc: 'Degraves Street',
        lookAtTarget: [{from: 0, x: -3700, y: -180, z: -2940, desc: 'from menu'}],
        pano: _.findWhere(this.panoramaArray,{name: 'Degraves'}),
        topic: 1,
        widgets: []

      },
      {
        id: 8,
        built: false,
        fov: 90,
        widgetStore: [],
        title: 'Bourke Street',
        desc: 'Bourke Street',
        lookAtTarget: [{from: 0, x: -1580, y: 360, z: -2940, desc: 'from menu'}],
        pano: _.findWhere(this.panoramaArray,{name: 'Bourke'}),
        topic: 1,
        widgets: []

      },
      {
        id: 9,
        built: false,
        fov: 90,
        widgetStore: [],
        title: 'Royal Arcade',
        desc: 'Royal Arcade',
        lookAtTarget: [{from: 0, x: -2560, y: 360, z: -960, desc: 'from menu'}],
        pano: _.findWhere(this.panoramaArray,{name: 'Royal Arcade'}),
        topic: 1,
        widgets: []

      },
      {
        id: 10,
        built: false,
        fov: 90,
        widgetStore: [],
        title: 'Treasury Building',
        desc: 'Treasury Building',
        lookAtTarget: [{from: 0, x: -400, y: -60, z: 1080, desc: 'from menu'}],
        pano: _.findWhere(this.panoramaArray,{name: 'Treasury Building'}),
        topic: 1,
        widgets: []

      },
      {
        id: 11,
        built: false,
        fov: 90,
        widgetStore: [],
        title: 'Exhibition Gardens',
        desc: 'Exhibition Gardens',
        lookAtTarget: [{from: 0, x: -1060, y: 360, z: 2200, desc: 'from menu'}],
        pano: _.findWhere(this.panoramaArray,{name: 'Exhibition'}),
        topic: 1,
        widgets: []

      }

    ];

  }





}
